import { useState, useCallback } from 'react';
import { UpsellModal } from 'components';
import NewReleaseModal from 'components/Modals/implementations/NewReleaseModal';
import UpgradeDistributionModal from 'components/Modals/UpgradeModal';
import { UploadAudioModal } from 'components/Modals/UploadAudioModal';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { useSubscription } from 'services/hooks';

interface NewReleaseModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const NewReleaseModalFlow = ({ isOpen, onClose }: NewReleaseModalProps) => {
  const { isFreeAccount, hasDistribution } = useSubscription();

  const [isUploadAudioModalOpen, setIsUploadAudioModalOpen] = useState(false);
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);
  const [isUpsellModalOpen, setIsUpsellModalOpen] = useState(false);

  const handleOpenUploadAudioModal = useCallback(() => {
    if (!hasDistribution) {
      if (isFreeAccount) {
        setIsUpgradeModalOpen(true);
      } else {
        setIsUpsellModalOpen(true);
      }
      return;
    }
    setIsUploadAudioModalOpen(true);
  }, [hasDistribution, isFreeAccount]);

  const handleUploadAudioModalClose = () => setIsUploadAudioModalOpen(false);
  const handleUpgradeModalClose = () => setIsUpgradeModalOpen(false);
  const handleUpsellModalClose = () => setIsUpsellModalOpen(false);

  return (
    <>
      <NewReleaseModal
        isOpen={isOpen}
        onClose={onClose}
        onOpenUploadAudioModal={handleOpenUploadAudioModal}
      />
      <UploadAudioModal
        isOpen={isUploadAudioModalOpen}
        onClose={handleUploadAudioModalClose}
      />
      <UpsellModal
        isOpen={isUpsellModalOpen}
        onClose={handleUpsellModalClose}
        location={AnalyticsEventLocation.NEW_RELEASE_MODAL}
      />
      <UpgradeDistributionModal
        isOpen={isUpgradeModalOpen}
        onClose={handleUpgradeModalClose}
        location={AnalyticsEventLocation.DISCOVERY_PAGE}
      />
    </>
  );
};

export default NewReleaseModalFlow;
